import React, { ForwardRefRenderFunction } from "react";
//#region types
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { InvoiceFormTypes } from "models/formTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { InvoicePreviewFormContainerProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { FormFieldConstants } from "utils/constants";
import { ObjectSchema } from "models/utilTypes/yupSchemaTypes";
//#endregion
//#region components
import InvoicePreviewForm from "./previewForm";
import useInvoiceFormValidations from "./create/useInvoiceFormValidations";
//#endregion
import * as Yup from "yup";

const InvoicePreviewFormContainer: ForwardRefRenderFunction<FormHandles, InvoicePreviewFormContainerProps> = (
  props,
  ref
) => {
  const {
    invoiceId,
    serialNumber,
    ocr,
    invoicePut,
    initialValues,
    canSendLastVersionToPagero,
    status,
    fromRecurring,
    recurringInvoiceVersion,
    recurringId,
    currency,
    isReminder,
    version,
    reminderFeesUpdateHandler,
    warnings,
    onInvoiceSendMethodSelected,
  } = props;

  const { getValidationSchemaSendEmail } = useInvoiceFormValidations();

  const validationSchema = React.useMemo(
    () =>
      Yup.object<InvoiceFormTypes.Preview>({
        sendType: Yup.number().required(TranslationKeys.Validations.Required),
        sendMail: Yup.object<InvoiceFormTypes.SendMail>().when(
          FormFieldConstants.Invoice.Preview.SendType,
          ([sendType], schema: ObjectSchema<InvoiceFormTypes.SendMail>) =>
            sendType === WintSuperkollAPIModel.InvoiceSendMethod.Email
              ? Yup.object<InvoiceFormTypes.SendMail>(getValidationSchemaSendEmail(false))
              : schema
        ),
        notes: Yup.string(),
        attachments: Yup.array().of(
          Yup.object<UploadedFile>({
            contentType: Yup.string(),
            fileName: Yup.string(),
            fileSize: Yup.number(),
            data: Yup.string(),
          })
        ),
        isInvoiceDraft: Yup.boolean(),
        reminderCost: Yup.number(),
        reminderDate: Yup.date().typeError(TranslationKeys.Validations.InvalidDate),
        reminderCostHidden: Yup.boolean(),
        mailOptions: Yup.object<InvoiceFormTypes.SendMailOptions>(),
      }),
    []
  );

  return (
    <InvoicePreviewForm
      ref={ref}
      defaultValues={initialValues}
      invoiceId={invoiceId}
      validationSchema={validationSchema}
      currency={currency}
      isReminder={isReminder}
      invoicePut={invoicePut}
      status={status}
      serialNumber={serialNumber}
      ocr={ocr}
      fromRecurring={fromRecurring}
      recurringInvoiceVersion={recurringInvoiceVersion}
      recurringId={recurringId}
      version={version}
      warnings={warnings}
      canSendLastVersionToPagero={canSendLastVersionToPagero}
      reminderFeesUpdateHandler={reminderFeesUpdateHandler}
      onInvoiceSendMethodSelected={onInvoiceSendMethodSelected}
      nextInvoiceSerialNumber={props.nextInvoiceSerialNumber}
    />
  );
};

export default React.forwardRef(InvoicePreviewFormContainer);
